/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
		GENERAL - hover .tile--property .content__inner add hoverclass to parent
		========================================================================== */

const tileHoverInit = function () {
  const tiles = document.querySelectorAll(".tile--property .content__inner, .tile--linked-tiles .content__inner");

  tiles.forEach(function (tileInner) {
    tileInner.addEventListener("mouseenter", function () {
      const parentTile = tileInner.closest(".tile--property, .tile--linked-tiles");
      if (parentTile) parentTile.classList.add("hover");
    });

    tileInner.addEventListener("mouseleave", function () {
      const parentTile = tileInner.closest(".tile--property, .tile--linked-tiles");
      if (parentTile) parentTile.classList.remove("hover");
    });
  });
}; // tileHoverInit();
tileHoverInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

const filterUpdateURL = function (filterData, searchData) {
  const url = new URL(window.location.href);
  // Remove existing filter params first
  filter_settings.filters.forEach(el => {
    url.searchParams.delete("filter_" + el.name);
  });
  url.searchParams.delete("search");

  // Add filter params for each active filter
  Object.keys(filterData).forEach(key => {
    if (filterData[key] && filterData[key].length > 0) {
      url.searchParams.set("filter_" + key, filterData[key].join(","));
    }
  });

  // Add search param (if applicable)
  if (searchData && searchData !== "") {
    url.searchParams.set("search", searchData);
  }

  // Preserve pagination (if it exists)
  const currentPageNum = new URL(window.location).searchParams.get("pagenum");
  if (currentPageNum) {
    url.searchParams.set("pagenum", currentPageNum);
  }

  // Update the browser URL without reloading
  window.history.pushState({ path: url.href }, "", url.href);
};

const filterGetPosts = function (sort = null) {
  let filterData = filterGetData();
  let filterSearchInput = document.querySelector(".filter__option input[type='search']");
  let searchData = filterSearchInput ? filterSearchInput.value : "";

  let sortData;

  if (sort === null) {
    sortData = window.currentSort || new URLSearchParams(window.location.search).get("sort") || "featured";
  } else {
    sortData = sort;
  }

  window.currentSort = sortData;

  // Update URL
  filterUpdateURL(filterData, searchData);

  const loadmoreContainer = document.querySelector(".loadmore-container");
  if (loadmoreContainer) loadmoreContainer.classList.add("filtering");

  const data = {
    action: "filter",
    query: php_variables.posts,
    filter_settings: filter_settings,
    filter_data: filterData,
    search_data: searchData,
    sort_data: sortData
  };

  $.ajax({
    url: php_variables.ajax_url,
    data: data,
    dataType: "json",
    type: "POST",
    success: function (data) {
      php_variables.current_page = 1;
      php_variables.posts = data.posts;
      php_variables.max_page = data.max_page;

      const pagingLoadmore = document.querySelector(".paging__loadmore");
      if (pagingLoadmore) {
        pagingLoadmore.style.display = data.max_page < 2 ? "none" : "block";
      }

      if (loadmoreContainer) {
        loadmoreContainer.innerHTML = data.content;
        loadmoreContainer.classList.remove("filtering");
      }

      // Update count
      const resultsCountEl = document.querySelector(".count");
      const resultsPluralEl = document.querySelector(".plural");
      if (resultsCountEl && resultsPluralEl) {
        const count = data.found_posts;
        resultsCountEl.textContent = `${count}`;
        resultsPluralEl.textContent = count !== 1 ? "s" : "";
      }

      lazyLoadInstance.update();
      filterUpdateActiveFilters();
    },
    error: function (err) {
      console.error("Filter AJAX error:", err);
    }
  });
};

const filterUpdateActiveFilters = function () {
  const activeFiltersContainer = document.querySelector(".active__filters");
  if (!activeFiltersContainer) return;

  // Clear existing active filters
  activeFiltersContainer.innerHTML = "";

  // Loop through all filter groups
  filter_settings.filters.forEach(group => {
    const checkedInputs = document.querySelectorAll('.filter__option input[name="' + group.name + '"]:checked');

    checkedInputs.forEach(input => {
      const labelText = input.closest("label").querySelector(".checkbox__label").textContent.trim();

      const activeFilter = document.createElement("div");
      activeFilter.classList.add("active__filter", "text-sml", "font-bold");
      activeFilter.dataset.filterGroup = group.name;
      activeFilter.dataset.filterValue = input.value;
      activeFilter.innerHTML = `${labelText} <i class="fa-solid fa-xmark"></i>`;

      activeFiltersContainer.appendChild(activeFilter);
    });
  });

  // If none selected, optionally hide the bar
  const filterBar = document.querySelector(".active__filters");
  if (filterBar) {
    filterBar.style.display = activeFiltersContainer.children.length > 0 ? "flex" : "none";
  }

  // Add click listeners to remove filters
  document.querySelectorAll(".active__filter").forEach(el => {
    el.addEventListener("click", function () {
      const group = this.dataset.filterGroup;
      const value = this.dataset.filterValue;

      // Uncheck the corresponding input
      const input = document.querySelector('.filter__option input[name="' + group + '"][value="' + value + '"]');
      if (input) {
        input.checked = false;
        const wrapper = input.closest(".filter__option");
        if (wrapper) wrapper.classList.remove("active");
      }

      // Re-filter after removing
      filterGetPosts();
      // Rebuild active filters
      filterUpdateActiveFilters();
    });
  });
};

const filterForm = document.querySelector(".filter__form");

const filterGetData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    const checkedOptions = document.querySelectorAll(
      '.filter__option input[type="checkbox"][name=' + el.name + "]:checked"
    );

    if (checkedOptions.length > 0) {
      const isAllChecked = Array.from(checkedOptions).some(opt => opt.value === "");
      if (!isAllChecked) {
        const values = Array.from(checkedOptions)
          .map(opt => opt.value)
          .filter(v => v !== "");
        if (values.length > 0) {
          filter_data[el.name] = values;
        }
      }
    }
  });

  return filter_data;
};

const filterInit = function () {
  const filterForm = document.querySelector(".filter__form");
  if (!filterForm) return;

  // Restore filters from URL on page load
  const urlParams = new URLSearchParams(window.location.search);
  filter_settings.filters.forEach(el => {
    const paramValue = urlParams.get("filter_" + el.name);
    if (paramValue) {
      const values = paramValue.split(",");
      values.forEach(val => {
        const input = document.querySelector('.filter__option input[name="' + el.name + '"][value="' + val + '"]');
        if (input) {
          input.checked = true;
        }
      });
    }
  });

  const allInputs = document.querySelectorAll(".filter__option input[type='checkbox']");
  allInputs.forEach(input => {
    const wrapper = input.closest(".filter__option");
    if (wrapper) {
      if (input.checked) {
        wrapper.classList.add("active");
      } else {
        wrapper.classList.remove("active");
      }
    }
  });

  // Run initial load if filters exist in URL
  // filterGetPosts();

  const filterOptions = document.querySelectorAll(".filter__option input");
  filterOptions.forEach(input => {
    if (input.type === "checkbox") {
      input.addEventListener("change", function () {
        const wrapper = this.closest(".filter__option");
        if (wrapper) {
          if (this.checked) {
            wrapper.classList.add("active");
          } else {
            wrapper.classList.remove("active");
          }
        }

        // “All” logic: if All checked, uncheck others; if others checked, uncheck All
        if (this.value === "") {
          const siblings = document.querySelectorAll('.filter__option input[name="' + this.name + '"]');
          siblings.forEach(opt => {
            if (opt !== this) {
              opt.checked = false;
              const sibWrapper = opt.closest(".filter__option");
              if (sibWrapper) sibWrapper.classList.remove("active");
            }
          });
        } else {
          const allOption = document.querySelector('.filter__option input[name="' + this.name + '"][value=""]');
          if (allOption) {
            allOption.checked = false;
            const allWrapper = allOption.closest(".filter__option");
            if (allWrapper) allWrapper.classList.remove("active");
          }
        }
      });
    }
  });

  // Apply Filters button click
  const applyButton = filterForm.querySelector("button[type='submit'], button:not([type])");
  if (applyButton) {
    applyButton.addEventListener("click", function (e) {
      e.preventDefault();
      filterGetPosts();

      // Close the filter modal after applying
      body.classList.remove("filter--open");
      filterModal.classList.remove("active");
      body.removeEventListener("mouseup", clickedOutsideFilter, false);
    });
  }

  filterForm.addEventListener("submit", function (e) {
    e.preventDefault();
    filterGetPosts();

    body.classList.remove("filter--open");
    filterModal.classList.remove("active");
    body.removeEventListener("mouseup", clickedOutsideFilter, false);
  });
  filterUpdateActiveFilters();
};
filterInit();

/*  ==========================================================================
    SORTING - AJAX sorting dropdown
    ========================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  const sortDropdowns = document.querySelectorAll(".sort__dropdown");

  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get("sort") || "featured";
  window.currentSort = currentSort;

  sortDropdowns.forEach(sortDropdown => {
    const trigger = sortDropdown.querySelector(".sort__trigger");
    const options = sortDropdown.querySelectorAll(".sort__option");
    const selected = sortDropdown.querySelector(".sort__selected");

    let matchedOption = Array.from(options).find(opt => opt.dataset.sort === currentSort);
    if (matchedOption) {
      options.forEach(o => o.classList.remove("active"));
      matchedOption.classList.add("active");
      selected.textContent = matchedOption.textContent;
    }

    trigger.addEventListener("click", e => {
      e.stopPropagation();
      sortDropdown.classList.toggle("active");
    });

    options.forEach(option => {
      option.addEventListener("click", () => {
        const sortValue = option.dataset.sort;
        const sortLabel = option.textContent;

        // Update label + UI
        selected.textContent = sortLabel;
        options.forEach(o => o.classList.remove("active"));
        option.classList.add("active");
        sortDropdown.classList.remove("active");

        // Sync across all dropdowns
        document.querySelectorAll(".sort__selected").forEach(sel => (sel.textContent = sortLabel));
        document.querySelectorAll(".sort__option").forEach(opt => {
          opt.classList.toggle("active", opt.dataset.sort === sortValue);
        });

        // Update global + trigger AJAX
        window.currentSort = sortValue;
        filterGetPosts(sortValue);
      });
    });
  });

  document.addEventListener("click", e => {
    document.querySelectorAll(".sort__dropdown.active").forEach(dd => {
      if (!dd.contains(e.target)) dd.classList.remove("active");
    });
  });
});

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    const isOpen = body.classList.contains(mobnavOpenclass);

    // ✅ Close search or pageheader modals if open
    body.classList.remove("search--open", "pageheader--open");
    searchNav?.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOutsideSearch, false);
    body.removeEventListener("mouseup", clickedOutsidePageheaderSearch, false);

    if (!isOpen) {
      // OPEN mobile nav
      body.classList.add(mobnavOpenclass);
      body.addEventListener("mouseup", clickedOutsideMobnav, false);
    } else {
      // CLOSE mobile nav
      body.classList.remove(mobnavOpenclass);
      body.removeEventListener("mouseup", clickedOutsideMobnav, false);
    }
  });
};
mobnavInit();

// Close mobile nav when clicking outside
const clickedOutsideMobnav = function (e) {
  const mobnav = document.querySelector(".mobnav");
  const mobnavToggle = document.querySelector(".mobnav-toggle");

  const clickedInside = mobnav.contains(e.target) || (mobnavToggle && mobnavToggle.contains(e.target));

  if (!clickedInside && body.classList.contains("mobnavopen")) {
    body.classList.remove("mobnavopen");
    body.removeEventListener("mouseup", clickedOutsideMobnav, false);
  }
};

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".search-toggle input");

const resetTagAnimations = function () {
  const tags = document.querySelectorAll(".siteheader__search .location__tags [data-location]");
  const settingTags = document.querySelectorAll(".siteheader__search .setting__tags .setting__tag:not(.hide)");
  tags.forEach(tag => {
    tag.classList.remove("animating", "animated", "reset__animation");
    tag.style.transitionDelay = "0s";
  });
  settingTags.forEach(tag => {
    tag.classList.remove("animating", "animated", "reset__animation");
    tag.style.transitionDelay = "0s";
  });
};

const resetTagAnimations2 = function () {
  const tags = document.querySelectorAll(".pageheader__search .location__tags [data-location]");
  const settingTags = document.querySelectorAll(".pageheader__search .setting__tags .setting__tag:not(.hide)");
  tags.forEach(tag => {
    tag.classList.remove("animating", "animated", "reset__animation");
    tag.style.transitionDelay = "0s";
  });
  settingTags.forEach(tag => {
    tag.classList.remove("animating", "animated", "reset__animation");
    tag.style.transitionDelay = "0s";
  });
};

// Close search modal whe/n clicking outside
const clickedOutsideSearch = function (e) {
  const clickedInsideSearch = searchNav.contains(e.target) || searchToggle.contains(e.target);
  if (!clickedInsideSearch) {
    searchNav.classList.remove("siteheader__search--open");
    body.classList.remove("search--open");
    body.removeEventListener("mouseup", clickedOutsideSearch, false);
    resetTagAnimations();
  }
};

// Tag filtering logic
const tagFilterInit = function () {
  const searchField = document.querySelector(".search-toggle input");
  const tags = document.querySelectorAll(".siteheader__search .location__tags [data-location]");

  if (!searchField || !tags.length) return;

  searchField.addEventListener("input", e => {
    const query = e.target.value.trim().toLowerCase();
    let visibleCount = 0;
    let matchFound = false;

    // Reset animations and visibility first
    tags.forEach(tag => {
      tag.classList.add("reset__animation");
      tag.classList.remove("animating", "animated");
      tag.style.transitionDelay = "0s";
    });

    // Show matching tags
    tags.forEach(tag => {
      const location = tag.dataset.location.toLowerCase();
      const text = tag.textContent.toLowerCase();
      const matches = location.includes(query) || text.includes(query);

      if (matches && visibleCount < 15) {
        tag.classList.remove("hide");
        visibleCount++;
        matchFound = true;
      } else {
        tag.classList.add("hide");
      }
    });
    if (searchField.value === "") {
      matchFound = false;
    }
    // If no matches, show top-level tags
    if (!matchFound) {
      tags.forEach(tag => {
        if (tag.dataset.parent === "0") {
          tag.classList.remove("hide");
        } else {
          tag.classList.add("hide");
        }
      });
    }

    setTimeout(() => {
      const visibleTags = document.querySelectorAll(".siteheader__search .location__tags [data-location]:not(.hide)");
      visibleTags.forEach((tag, index) => {
        tag.classList.add("animating");
        tag.classList.remove("reset__animation");
        tag.style.transitionDelay = `${index * 0.05}s`; // staggered fade-in
      });
    }, 100);
  });

  // Initial state — show only toplevel tags
  tags.forEach(tag => {
    if (tag.dataset.parent === "0") {
      tag.classList.remove("hide");
    } else {
      tag.classList.add("hide");
    }
  });
};
const tagFilterInit2 = function () {
  const searchField = document.querySelector(".pageheader__search input");
  const tags = document.querySelectorAll(".pageheader__search .location__tags [data-location]");

  if (!searchField || !tags.length) return;

  searchField.addEventListener("input", e => {
    const query = e.target.value.trim().toLowerCase();
    let visibleCount = 0;
    let matchFound = false;

    // Reset animations and visibility first
    tags.forEach(tag => {
      tag.classList.add("reset__animation");
      tag.classList.remove("animating", "animated");
      tag.style.transitionDelay = "0s";
    });

    // Show matching tags
    tags.forEach(tag => {
      const location = tag.dataset.location.toLowerCase();
      const text = tag.textContent.toLowerCase();
      const matches = location.includes(query) || text.includes(query);

      if (matches && visibleCount < 15) {
        tag.classList.remove("hide");
        visibleCount++;
        matchFound = true;
      } else {
        tag.classList.add("hide");
      }
    });
    if (searchField.value === "") {
      matchFound = false;
    }
    // If no matches, show top-level tags
    if (!matchFound) {
      tags.forEach(tag => {
        if (tag.dataset.parent === "0") {
          tag.classList.remove("hide");
        } else {
          tag.classList.add("hide");
        }
      });
    }

    setTimeout(() => {
      const visibleTags = document.querySelectorAll(".pageheader__search .location__tags [data-location]:not(.hide)");
      visibleTags.forEach((tag, index) => {
        tag.classList.add("animating");
        tag.classList.remove("reset__animation");
        tag.style.transitionDelay = `${index * 0.05}s`; // staggered fade-in
      });
    }, 100);
  });

  // Initial state — show only toplevel tags
  tags.forEach(tag => {
    if (tag.dataset.parent === "0") {
      tag.classList.remove("hide");
    } else {
      tag.classList.add("hide");
    }
  });
};

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  body.classList.remove(mobnavOpenclass);

  const visibleTags = document.querySelectorAll(".siteheader__search .location__tags [data-location]:not(.hide)");
  const settingTags = document.querySelectorAll(".siteheader__search .setting__tags .setting__tag:not(.hide)");

  visibleTags.forEach((tag, index) => {
    tag.classList.add("animating");
    tag.classList.remove("reset__animation");
    // staggered fade-in
    tag.style.transitionDelay = `${index * 0.05}s`;
  });
  settingTags.forEach((tag, index) => {
    tag.classList.add("animating");
    // staggered fade-in
    tag.style.transitionDelay = `${index * 0.05}s`;
  });
  setTimeout(() => {
    settingTags.forEach((tag, index) => {
      // staggered fade-in
      tag.style.transitionDelay = `0s`;
    });
  }, 100);
  const isOpen = searchNav.classList.contains("siteheader__search--open");
  const isIconClick = e.target.closest(".search__icon");

  if (isOpen && isIconClick) {
    // Close only if open AND the icon is clicked
    searchNav.classList.remove("siteheader__search--open");
    body.classList.remove("search--open");
    body.removeEventListener("mouseup", clickedOutsideSearch, false);
    resetTagAnimations();
  } else if (!isOpen) {
    // Open
    searchNav.classList.add("siteheader__search--open");
    body.classList.add("search--open");

    body.addEventListener("mouseup", clickedOutsideSearch, false);
    searchInput.focus();
  }
};

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
  tagFilterInit();
};
searchModalInit();

// searchModalInit();

const pageheaderSearchToggle = document.querySelector(".pageheader__form");

// Toggle search modal window
const pageheaderSearchModalToggle = function (e) {
  e.preventDefault();
  body.classList.remove(mobnavOpenclass);
  const searchField = document.querySelector(".pageheader__search input");

  const visibleTags = document.querySelectorAll(".pageheader__search .location__tags [data-location]:not(.hide)");
  const settingTags = document.querySelectorAll(".pageheader__search .setting__tags .setting__tag:not(.hide)");
  setTimeout(() => {
    visibleTags.forEach((tag, index) => {
      tag.classList.add("animating");
      tag.classList.remove("reset__animation");
      // staggered fade-in
      tag.style.transitionDelay = `${index * 0.05}s`;
    });
    settingTags.forEach((tag, index) => {
      tag.classList.add("animating");
      // staggered fade-in
      tag.style.transitionDelay = `${index * 0.05}s`;
    });
  }, 100);
  setTimeout(() => {
    settingTags.forEach((tag, index) => {
      tag.classList.add("animating");
      // staggered fade-in
      tag.style.transitionDelay = `0s`;
    });
    searchField.focus();
  }, 500);

  const isOpen = body.classList.contains("pageheader--open");

  if (isOpen) {
    // Close if already open
    body.classList.remove("pageheader--open");
    body.removeEventListener("mouseup", clickedOutsidePageheaderSearch, false);
    resetTagAnimations2();
  } else {
    // Open
    body.classList.add("pageheader--open");
    body.addEventListener("mouseup", clickedOutsidePageheaderSearch, false);
  }
};

// Close pageheader search when clicking outside
const clickedOutsidePageheaderSearch = function (e) {
  const pageheaderSearch = document.querySelector(".pageheader__search");
  const clickedInside =
    pageheaderSearch.contains(e.target) || (pageheaderSearchToggle && pageheaderSearchToggle.contains(e.target));

  if (!clickedInside && body.classList.contains("pageheader--open")) {
    body.classList.remove("pageheader--open");
    body.removeEventListener("mouseup", clickedOutsidePageheaderSearch, false);
    resetTagAnimations2();
  }
};

const pageheaderSearchModalInit = function () {
  if (!pageheaderSearchToggle) {
    return;
  }
  pageheaderSearchToggle.addEventListener("click", pageheaderSearchModalToggle);
  tagFilterInit2();
};
pageheaderSearchModalInit();

/*  ==========================================================================
    FILTER MODAL
    ========================================================================== */

const filterBarToggle = document.querySelector(".open__filter");
const filterModal = document.querySelector(".filter__modal");
const filterModalOpenClass = "filter--open";

// Close when clicking outside
const clickedOutsideFilter = function (e) {
  const clickedInside =
    filterModal.querySelector(".filter__search").contains(e.target) || filterBarToggle.contains(e.target);
  if (!clickedInside && body.classList.contains(filterModalOpenClass)) {
    body.classList.remove(filterModalOpenClass);
    filterModal.classList.remove("active");
    body.removeEventListener("mouseup", clickedOutsideFilter, false);
  }
};

// Open/Close modal on click
const filterModalToggle = function (e) {
  e.preventDefault();
  const isOpen = body.classList.contains(filterModalOpenClass);

  // Close other modals
  body.classList.remove("mobnavopen", "search--open", "pageheader--open");

  if (!isOpen) {
    // OPEN
    body.classList.add(filterModalOpenClass);
    filterModal.classList.add("active");
    body.addEventListener("mouseup", clickedOutsideFilter, false);
  } else {
    // CLOSE
    body.classList.remove(filterModalOpenClass);
    filterModal.classList.remove("active");
    body.removeEventListener("mouseup", clickedOutsideFilter, false);
  }
};

const filterModalInit = function () {
  if (!filterBarToggle || !filterModal) return;
  filterBarToggle.addEventListener("click", filterModalToggle);
};
filterModalInit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();
